import React, { FC, ReactElement } from 'react'
import styles from './WalletItems.module.css'
import { WalletTabs, WalletFilters } from '../'
import InscriptionCard from '../inscription-card'
import SoldInscriptionCard from '../sold-inscription-card'
import InscriptionSalePrice from '@/components/inscription-actions/inscription-sale-price'
import InscriptionActions from '@/components/inscription-actions'
import { Inscription } from '@/utils/types/inscription'
import CardScroller from '@/components/card-scroller/CardScroller'

const WalletItems: FC<{
	isLoading: boolean
	selectedTab: WalletTabs
	inscriptions: Inscription[]
	mutate: () => void
	columns: any
	filter: WalletFilters
	setLocalEscrows?: () => void
}> = (props): ReactElement => {
	const {
		isLoading: _isLoading,
		columns: _columns,
		inscriptions,
		mutate,
		selectedTab,
		filter: _filter
	} = props

	const renderInscription = (e: any, _i: any) => {
		if (selectedTab === 'Sold') {
			return (
				<SoldInscriptionCard
					key={e?.id}
					inscription={e}
					footer={<InscriptionSalePrice key={e?.id} price={e?.escrow?.satoshi_price} />}
				/>
			)
		}

		return (
			<InscriptionCard
				onClick={() => {}}
				selected={false}
				key={e?.id}
				showSetPfp={true}
				showSetSns={true}
				inscription={e}
				footer={
					<InscriptionActions
						key={e?.id}
						onLocalUpdate={mutate}
						inscription={e}
						owner={true}
						actionClassName={styles.action}
						actionButtonColor="black"
					/>
				}
			/>
		)
	}

	return (
		<div className={styles.root}>
			<CardScroller items={inscriptions} renderItem={renderInscription} />
		</div>
	)
}

export default WalletItems
